<script setup>
import {computed, watch} from "vue"

import InputText from "@/components/form/InputText.vue"

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: ''
  },
  min: {
    type: Number,
    default: 0
  },
  validator: {
    type: Object,
    default: () => {
    }
  },
  error: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['update:modelValue'])

const subscriptionAmount = computed( {
  get() {
    return props.modelValue
  },
  set(value) {
    value = parseInt(value)
    emits('update:modelValue', value)
  }
})

watch(
  () => subscriptionAmount.value,
  (newValue) => {
    if (!newValue || newValue < props.min) {
      console.log('reset')
      subscriptionAmount.value = props.min
    }
  }
)

const handleAmountDecrease = (amount) => {
  subscriptionAmount.value = Math.max(2, subscriptionAmount.value - amount)
}

const handleAmountIncrease = (amount) => {
  subscriptionAmount.value += amount
}
</script>

<template>
  <div class="step-numbers__counter">
    <button
      @click="handleAmountDecrease(1)"
      class="step-numbers__button step-numbers__button--minus"
      id="decrement"
    ></button>
    <div class="step-numbers__count">
      <InputText
        type="number"
        style="all:unset; max-width: 50px; text-align: right"
        v-model="subscriptionAmount"
        :validator="validator"
        :error="error"
      /> {{ $t('users', subscriptionAmount) }}
    </div>
    <button
      @click="handleAmountIncrease(1)"
      class="step-numbers__button step-numbers__button--plus"
      id="increment"
    ></button>
  </div>
</template>